import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface UsersApiConfigOptions extends ApiConfigOptions {}
export class UsersApiConfig extends Configuration {
  constructor(configOptions?: UsersApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
